export default __webpack_public_path__ + "static/media/noa-15.e014f339.jpg";